import React, { useEffect } from "react";
import { connect } from "react-redux";
import get from "../../utils/get";
import * as actions from '../actions/forgot'
import ForgotPassword from "../screens/ForgotPasswordScreen"

const ForgotPasswordContainer = (props) => {
  //useEffect(() => {});
  return (
    <ForgotPassword
      {...props}
    />
  );
};

const mapStateToProps = (state) => ({
  isLoading: get(state, "login.forgot.isLoading"),
});

const mapActionsToProps = { ...actions };

export default connect(mapStateToProps, mapActionsToProps)(ForgotPasswordContainer);
